import {Model} from "./";
import {Api} from "../api";

class QuizModel extends Model {
    constructor() {
        super(new Api("/quiz"));
    }

    postAnswers(ob, thenFunction, errorFunction) {
        this.q.setDopUrl('');
        this.q.create({data: ob}, thenFunction, errorFunction);
    }

    getAnswers(thenFunction, errorFunction) {
        this.q.setDopUrl('');
        this.q.read({}, thenFunction, errorFunction);
    }

    getLast(thenFunction, errorFunction) {
        this.q.setDopUrl('/last');
        this.q.read({}, thenFunction, errorFunction);
    }

}


export default new QuizModel();